import React, {useEffect} from 'react';
import Select from 'react-select';
import styled from "styled-components";
import {getCssSizeValue, getFontSize} from "@/utils/utils";
import {BREAKPOINTS} from "@/styles/themeSettings";
import {ICONS} from "@/constants";
import Icon from "@/components/common/Icon/Icon";
import {useRouter} from "next/router";

const CustomSelectWrapper = styled.div`
    width: 100%;
    border: none;

    .react-select-project__menu-list {
            //background-color: ${({theme}) => theme.colors.chilliRed};
        //max-height: 170px;
    }

    .react-select-project__placeholder {
        color: ${({theme}) => theme.colors.richBlack};
    }

    .react-select-project__menu {
        color: ${({theme}) => theme.colors.richBlack};
        font-family: ${({theme}) => theme.fontFamily.StrawfordFont};
        font-size: ${getFontSize(18, BREAKPOINTS.MOBILE)};
        line-height: ${getFontSize(21.6, BREAKPOINTS.MOBILE)};
        font-weight: ${({theme}) => theme.fontWeight.medium};
        @media (min-width: ${({theme}) => theme.breakpoints.tablet}px) {
            font-size: ${getFontSize(18, BREAKPOINTS.TABLET)};
            line-height: ${getFontSize(21.6, BREAKPOINTS.TABLET)};
        }
        @media (min-width: ${({theme}) => theme.breakpoints.desktop}px) {
            font-size: ${getFontSize(18, BREAKPOINTS.DESKTOP)};
            line-height: ${getFontSize(21.6, BREAKPOINTS.DESKTOP)};
        }
    }

    .icon {
        fill: ${({theme}) => theme.colors.white} !important;
    }
`;

const CustomControl = styled.div`
	display: flex;
	align-items: center;
	//padding: 8px;
	padding-left: 38px;
	//background-color: ${({theme}) => theme.colors.white};
	background-color: transparent;
	//border: 1px solid ${({theme}) => theme.colors.richBlack};
	border: transparent;
	color: ${({theme}) => theme.colors.richBlack};
	height: 50px;
	min-height: 50px;
	&.has-value {
		padding-left: 20px;
	}
	font-family: ${({theme}) => theme.fontFamily.StrawfordFont};
	font-size: ${getFontSize(18, BREAKPOINTS.MOBILE)};
	line-height:${getFontSize(21.6, BREAKPOINTS.MOBILE)};
	font-weight: ${({theme}) => theme.fontWeight.medium};
	@media (min-width: ${({theme}) => theme.breakpoints.tablet}px) {
		font-size: ${getFontSize(18, BREAKPOINTS.TABLET)};
		line-height: ${getFontSize(21.6, BREAKPOINTS.TABLET)};
	}
	@media (min-width: ${({theme}) => theme.breakpoints.desktop}px) {
		font-size: ${getFontSize(18, BREAKPOINTS.DESKTOP)};
		line-height: ${getFontSize(21.6, BREAKPOINTS.DESKTOP)};
	}
`;

const MobileSelectButton = styled.div`
	width: 40px;
	height: 40px;
	background-color: ${({theme}) => theme.colors.chilliRed};
	border-radius: 4px;
	position: absolute;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	right: ${getCssSizeValue(20, BREAKPOINTS.MOBILE)};
	svg {
		width: 14px;
		transform: rotate(90deg);
	}
	@media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		display: none;
	}
`

const PaymentPurpose = styled.p`
	color: ${({theme}) => theme.colors.chilliRed};
	position: relative;
	margin-top: 20px;
	&:before {
		content: '';
		height: 2px;
		width: 100%;
		position: absolute;
		bottom: 5px;
		left: 0;
		background-color: ${({theme}) => theme.colors.chilliRed};
	}
`

const CustomOption = styled.div`
  padding: 10px 20px;
  cursor: pointer;
	&::-webkit-scrollbar {
		display: none;
	}
  &:hover {
    background-color: ${({theme}) => theme.colors.antiflashWhite};
  }
`;

const customComponents = {
	Control: ({ children, ...props }) => {
		const { getValue } = props.selectProps;
		const selectedOption = getValue()[0];
		// console.log(selectedOption);
		return (
			<CustomControl className={selectedOption ? 'has-value' : ''} {...props.innerProps}>
				<>
					{selectedOption && (
						<>
							{/*<CountryFlag*/}
							{/*	countryCode={selectedOption.word}*/}
							{/*	svg*/}
							{/*	style={{ width: '20px', marginRight: '7px' }}*/}
							{/*/>*/}
							<PaymentPurpose className='typo-borna typo-borna-58'>{selectedOption.value}</PaymentPurpose>
							{children}
						</>)}
					{!selectedOption && children}
				</>
			</CustomControl>
		);
	},
	Option: ({ children, ...props }) => {
		return(
			<CustomOption
				{...props.innerProps}
				isSelected={props.isSelected}
				isFocused={props.isFocused}
			>
				<p>{props.data.value}</p>
				{children}
			</CustomOption>
		)},
	DropdownIndicator: ({children, ...props}) => {
		return(
			<MobileSelectButton><Icon name={ICONS.CHEVRON}/></MobileSelectButton>
		)
	}
};

const ProjectSelector = ({ value, onChange, language, placeholder, options }) => {
	return (
		<CustomSelectWrapper>
			<Select
				classNamePrefix="react-select-project"
				components={customComponents}
				options={options}
				placeholder={placeholder}
				value={options.find((option) => option.index === value)}
				onChange={onChange}
				isSearchable={false}
				getValue={() => [options.find((option) => option.index === value)]}
			/>
		</CustomSelectWrapper>
	);
};

export default ProjectSelector;
